import api from "./axiosClient";

// Base routes
const QUESTION_API_BASE = "https://zenqb.com/api/questions";
const GROQ_API_BASE = "https://zenqb.com/api";  // <-- new backend base route
//const QUESTION_API_BASE = "http://localhost:5000/api/questions";
//const GROQ_API_BASE = "http://localhost:5000/api";  // <-- new backend base route
//const QUESTION_API_BASE = "http://127.0.0.1:5000/api/questions";
//const GROQ_API_BASE = "http://127.0.0.1:5000/api";  // <-- new backend base route

// -------------------
// Question APIs
// -------------------

export const getAllQuestions = async () => {
  const res = await api.get(`${QUESTION_API_BASE}/`);
  return res.data;
};

// export const getFilters = async (board = '', grade = '', subject = '', year = '') => {
//   const params = new URLSearchParams();
//   if (board) params.append('board', board);
//   if (grade) params.append('grade', grade);
//   if (subject) params.append('subject', subject);
//   if (year) params.append('year', year);

//   const res = await fetch(`${QUESTION_API_BASE}/filters?${params.toString()}`);
//   return await res.json();
// };

export const getFilters = async ({
  category = '',
  program = '',
  board = '',
  grade = '',
  stream = '',
  subject = '',
  year = '',
  term = '',
  month = ''
}) => {
  const params = new URLSearchParams();

  if (category) params.append('category', category);
  if (program) params.append('program', program);
  if (board) params.append('board', board);
  if (grade) params.append('grade', grade);
  if (stream) params.append('stream', stream);
  if (subject) params.append('subject', subject);
  if (year) params.append('year', year);
  if (term) params.append('term', term);
  if (month) params.append('month', month);

  const res = await api.get(
    `${QUESTION_API_BASE}/v2/filters?${params.toString()}`
  );

  return res.data;
};


export const getAIExplanation = async (question) => {
  const res = await api.post(`${QUESTION_API_BASE}/explain_ai`, question); 
return res.data;
};

export const getFrequentlyAsked = async ({
  category = '',
  program = '',
  board = '',
  stream = '',
  grade = '',
  subject = '',
  limit = 20,
  q = '',
}) => {
  const params = new URLSearchParams();

  if (category) params.append('category', category);
  if (program) params.append('program', program);
  if (board) params.append('board', board);
  if (stream) params.append('stream', stream);
  if (grade) params.append('grade', grade);
  if (subject) params.append('subject', subject);
  if (q) params.append('q', q);
  params.append('limit', limit);

  const res = await api.get(
    `${QUESTION_API_BASE}/frequently-asked?${params.toString()}`
  );

  return res.data;
};
// -------------------
// AI / Groq APIs
// -------------------

// This is your chatbot explanation API (now routed through backend)
export const getAIChatExplanation = async (prompt) => {
  const res = await api.post(`${GROQ_API_BASE}/get-chat-explanation`, { prompt });
  return res.data.answer; // backend returns { answer: "...text..." }
};

export const generateAnswerForQuestionBackend = async (question) => {
  const res = await api.post(`${QUESTION_API_BASE}/generate_question_explain_ai`, question); 
  //const res = await api.post(`${GROQ_API_BASE}/generate-answer`, question); 
  return res.data;
};

// -------------------
// New Question APIs (v2 - Relational + Pagination)
// -------------------

export const getQuestionsV2 = async ({
  category = '',
  program = '',
  board = '',
  stream = '',
  grade = '',
  subject = '',
  year = '',
  term = '',
  question_type = '',
  difficulty = '',
  page = 1,
  per_page = 20,
}) => {
  const params = new URLSearchParams();

  if (category) params.append('category', category);
  if (program) params.append('program', program);
  if (board) params.append('board', board);
  if (stream) params.append('stream', stream);
  if (grade) params.append('grade', grade);
  if (subject) params.append('subject', subject);
  if (year) params.append('year', year);
  if (term) params.append('term', term);
  if (question_type) params.append('question_type', question_type);
  if (difficulty) params.append('difficulty', difficulty);

  params.append('page', page);
  params.append('per_page', per_page);

  const res = await api.get(
    `${QUESTION_API_BASE}/v2?${params.toString()}`
  );

  return res.data;
};

export const getTeasers = async (limit = 5, category = "school") => {
  const res = await api.get(
    `${QUESTION_API_BASE}/teasers?limit=${limit}&category=${category}`
  );

  return res.data;
};
